import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TabNames, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";

@Component({
  selector: "app-tab-video-component",
  templateUrl: "./tab-video-component.component.html",
  styleUrls: ["./tab-video-component.component.scss"],
})
export class TabVideoComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService
  ) {}

  @Input() tab_id: string;
  tab: Tab;
  mode: string;

  // default values
  imageLg: string;
  imageSm: string;
  image: string;
  icon: string;
  icon_ios: string;
  title: string;
  roundedBottom = true;
  offCanvasSubscription: any;
  enableStickyPost = false;
  textColor = "#ffffff";
  stickyBgColor = "#ff2121";
  offcanvasColors = offcanvasColors;
  newTab = false;
  videoUrl='';
  videoDesc = '';
  bgColor = '';
  ngOnInit() {
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "tab" &&
          data.tab.id == this.tab_id
        ) {
          this.tab = { ...data.tab };
          this.mode =localStorage.getItem("mode");

          if (this.tab.video_url) {
            this.videoUrl = this.tab.video_url;
          }
          if (this.tab.desc) {
            this.videoDesc = this.tab.desc;
          }
          if (this.tab.text_color) {
            this.textColor = this.tab.text_color;
          }
          if (this.tab.bg_color) {
            this.bgColor = this.tab.bg_color;
          }
        }
      }
    );
  }


  colorTextPickerChange(event) {
    this.tab.text_color = event;
    this.mdw.changeTab({tab: this.tab}, this.mode, false)
  }

  colorBgPickerChange(event) {
    this.tab.bg_color = event;
    this.mdw.changeTab({tab: this.tab}, this.mode, false)
  }

  videoUrlChange(event) {
    this.tab.video_url = event;
    this.mdw.changeTab({tab: this.tab}, this.mode, false)
  }
  videoDescChange(event) {
    this.tab.desc = event;
    this.mdw.changeTab({tab: this.tab}, this.mode, false)
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
